import { render, staticRenderFns } from "./activityDiscussion.html?vue&type=template&id=58490bb4&external"
import script from "./activityDiscussion.vue?vue&type=script&lang=js"
export * from "./activityDiscussion.vue?vue&type=script&lang=js"
import style0 from "./activityDiscussion.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports